const selectors = {
  addOnLocation: "add-on-product-card",
};
export default selectors;
